import { Text, ThemingContext } from '@doordash/design-language';
import { ModalHeaderImage } from './styles';
import NavBar from '@doordash/component-navbar';
import PropTypes from 'prop-types';
import React from 'react';

var DefaultContentHeader = function DefaultContentHeader(_ref) {
  var closeButtonAccessibilityLabel = _ref.closeButtonAccessibilityLabel,
      hasPadding = _ref.hasPadding,
      headerAlignment = _ref.headerAlignment,
      headerImage = _ref.headerImage,
      hasCloseButton = _ref.hasCloseButton,
      onClose = _ref.onClose,
      subtitle = _ref.subtitle,
      title = _ref.title;
  var theme = React.useContext(ThemingContext);
  return React.createElement("div", null, headerImage && React.createElement(ModalHeaderImage, {
    modalBorderRadius: theme.BorderRadius.ModalDefault
  }, headerImage), React.createElement(NavBar, {
    onNavigationClick: onClose,
    navigationType: headerImage || !hasCloseButton ? NavBar.NavigationTypes.None : NavBar.NavigationTypes.Close,
    noContentPadding: !hasPadding,
    subtext: subtitle,
    strings: {
      navigationButtonLabel: hasCloseButton ? closeButtonAccessibilityLabel : null
    },
    textAlign: headerAlignment,
    title: title,
    titleSize: NavBar.TitleSizes.Large
  }));
};

DefaultContentHeader.propTypes = {
  closeButtonAccessibilityLabel: PropTypes.string,
  onClose: PropTypes.func,
  headerAlignment: PropTypes.oneOf([Text.TextAlignments.Left, Text.TextAlignments.Center]).isRequired,
  headerImage: PropTypes.node,
  title: PropTypes.node,
  subtitle: PropTypes.string,
  hasCloseButton: PropTypes.bool.isRequired,
  hasContent: PropTypes.bool.isRequired,
  hasPadding: PropTypes.bool,
  titleId: PropTypes.string.isRequired,
  subtitleId: PropTypes.string
};
export default DefaultContentHeader;